import { useCallback, useMemo } from 'react';
import Decimal from 'decimal.js';
import { ScrollSyncPane } from 'react-scroll-sync';

import { StyledCheckboxDone } from '../../atoms/SettlementsDoneElement/StyledCheckboxDone';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledAllPayTrainer } from '../../atoms/UserPanelAllTrainerPay/StyledAllPayTrainer';
import { StyledScrolContentPayAll } from '../../atoms/UserPanelAllTrainerPay/StyledScrolContentPayAll';
import { StyledFlexBoxWrapper } from './OpenElement.styles';

import { ReactComponent as CheckboxAccept } from '../../../images/checkboxAccept.svg';

const TrainerRow = ({
    trainer,
    showCheckboxes,
    keyElement,
    onChangeCheckedTrainers,
    checkedTrainers,
}) => {
    const rowBorder = useMemo(() => {
        if (trainer.is_admin) {
            return '#5FEE5C'; //Always green for admins
        }
        const [year, monthNum] = keyElement.split('-').map(Number);
        if (trainer.salary) {
            switch (trainer.salary.paid) {
                case 1:
                    return '#5FEE5C'; //green - paid
                case 2:
                    return '#F9EC4B'; //yellow - partially paid
                default:
                    if (new Decimal(trainer.salary.totalAmount).eq(0)) return '#5FEE5C'; //green - paid
                    if (new Date().getMonth() + 1 > monthNum) return '#EE745C'; //red - not paid
                    else return '#6786BE'; //default
            }
        } else {
            if (new Decimal(trainer.pay).eq(0)) return '#5FEE5C'; // Green - paid

            if (year < new Date().getFullYear()) {
                return '#EE745C'; // Red - not paid
            } else {
                if (new Date().getMonth() + 1 > monthNum) {
                    if (!trainer.salary) return '#EE745C'; // Red - not paid
                } else {
                    return '#6786BE'; //Default
                }
            }
        }
    }, [trainer, keyElement]);

    const hasManagerHours = useMemo(() => {
        return trainer.managerHours > 0;
    }, [trainer]);

    return (
        <StyledFlexBoxWrapper key={trainer.id}>
            <ScrollSyncPane>
                <StyledScrolContentPayAll>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {showCheckboxes ? (
                            <StyledCheckboxDone
                                $isDisabled={
                                    trainer.salary?.paid === 1 ||
                                    new Decimal(trainer.pay).eq(0) ||
                                    trainer.is_admin === true
                                }
                            >
                                <input
                                    type="checkbox"
                                    id={`pay-${trainer.id}-${keyElement}`}
                                    disabled={
                                        trainer.salary?.paid === 1 ||
                                        new Decimal(trainer.pay).eq(0) ||
                                        trainer.is_admin === true
                                    }
                                    onChange={() => onChangeCheckedTrainers(trainer)}
                                    checked={checkedTrainers.some((t) => t.id === trainer.id)}
                                />
                                <label htmlFor={`pay-${trainer.id}-${keyElement}`}>
                                    <CheckboxAccept />
                                </label>
                            </StyledCheckboxDone>
                        ) : undefined}
                        <StyledAllPayTrainer bordercolor={rowBorder}>
                            <div>
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredfontweight="600"
                                    hasdeclaredlineheight="1.4em"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="0 4px 2px 4px"
                                >
                                    {trainer.name}
                                </StyledText>
                            </div>
                            <div>
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredfontweight="600"
                                    hasdeclaredlineheight="1.4em"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="0 4px 2px 4px"
                                >
                                    {trainer.totalHours || trainer.hours}{' '}
                                    {hasManagerHours &&
                                        `(${trainer.hours} | ${trainer.managerHours})`}
                                </StyledText>
                            </div>
                            <div>
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredfontweight="600"
                                    hasdeclaredlineheight="1.4em"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="0 4px 2px 4px"
                                >
                                    {new Decimal(trainer.pay).toFixed(2)} PLN{' '}
                                    {trainer.salary && trainer.salary.paid === 2
                                        ? `(${Decimal(trainer.salary.totalAmount)
                                              .minus(trainer.salary.paidAmount)
                                              .toNumber()
                                              .toFixed(2)} PLN)`
                                        : null}
                                </StyledText>
                            </div>
                            <div>
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredfontweight="600"
                                    hasdeclaredlineheight="1.4em"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="0 4px 2px 4px"
                                >
                                    {new Decimal(trainer.price).minus(trainer.pay).toFixed(2)} PLN
                                </StyledText>
                            </div>
                            <div>
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredfontweight="600"
                                    hasdeclaredlineheight="1.4em"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="0 4px 2px 4px"
                                >
                                    {new Decimal(trainer.price)
                                        .minus(trainer.free_hours_price)
                                        .toFixed(2)}{' '}
                                    PLN
                                </StyledText>
                            </div>
                        </StyledAllPayTrainer>
                    </div>
                </StyledScrolContentPayAll>
            </ScrollSyncPane>
        </StyledFlexBoxWrapper>
    );
};

export default TrainerRow;
